module.exports = __webpack_public_path__ + "static/img/m_index_02.bd959f75.jpg";